import ZoneRenderer from "src/components/common/ZoneRenderer";

const BackgroundWrapper = (props) => {
  const { backgroundColor } = props.item?.fields || {};
  return (
    <div
      className="background-wrapper"
      style={{ backgroundColor }}
    >
      <div className="container">
        <ZoneRenderer zone={props.subModules} />
      </div>
    </div>
  );
};

export default BackgroundWrapper;
